var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "fish-counter" },
      [
        _c(
          "button",
          {
            staticClass: "fish-counter__button purchase-fish",
            on: { click: _vm.handlePurchaseFish },
          },
          [
            _c("img", {
              staticClass: "fish-counter__fish-icon",
              attrs: {
                src: require("@/assets/img/icon/fish_icon.png"),
                alt: "Fish",
              },
            }),
            _c("div", [_vm._v(_vm._s(_vm.formattedCurrentFish))]),
          ]
        ),
        _vm.isFree
          ? [
              _c(
                "button",
                {
                  staticClass: "fish-counter__button upgrade",
                  on: { click: _vm.handleAddClick },
                },
                [
                  _vm._m(0),
                  _c("span", { staticClass: "fish-counter__button-text" }, [
                    _vm._v("アップグレード"),
                  ]),
                ]
              ),
            ]
          : [
              _c("img", {
                attrs: {
                  src: require("@/assets/img/icon/premium.png"),
                  alt: "プレミアム",
                  width: "24",
                  height: "24",
                },
              }),
            ],
      ],
      2
    ),
    _vm.isShowCoachMark
      ? _c("div", { staticClass: "fish-counter__coach-mark" }, [
          _c(
            "div",
            { staticClass: "fish-counter__coach-mark-content" },
            [
              _c("div", [_vm._v("もっとほしいにゃ！")]),
              _c("CatIcon", {
                staticClass: "fish-counter__coach-mark-cat-icon",
                attrs: {
                  size: _vm.catIconSize,
                  writerType: _vm.writerType?.tendency,
                },
              }),
              _c(
                "button",
                {
                  staticClass: "fish-counter__coach-mark-close",
                  on: { click: _vm.handleCloseCoachMark },
                },
                [_vm._v("×")]
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "fish-counter__premium-icon-wrapper" }, [
      _c("img", {
        staticClass: "fish-counter__premium-icon",
        attrs: {
          src: require("@/assets/img/icon/premium.png"),
          alt: "プレミアム",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }